import { Component, Input, inject, PLATFORM_ID, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export interface ChartsData {
  labels: any[];
  datasets: ChartsDataSets[];
}

export interface ChartsDataSets {
  label: string[];
  data: number[];
}

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
})
export class ChartsComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);
  readonly isBrowser = isPlatformBrowser(this.platformId);

  legendData = [{ color: '', value: '' }];

  @Input() type: string = '';
  @Input() data: any;
  @Input() height!: string;
  @Input() width!: string;
  @Input() options: any;

  ngOnInit() {
    if (
      this.isBrowser &&
      (this.type === 'doughnut' || this.type == 'pie')
    ) {
      setTimeout(() => {
        this.legendData = this.data.datasets[0].backgroundColor.map(
          (color: string, index: number) => ({
            color,
            value: this.data.labels[index],
          }),
        );
      }, 10);
    }
  }
}
